import { HeaderAction } from '@shared/components/header/header.component';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'syn-header-actions-button',
    templateUrl: 'header-actions-button.component.html',
    styleUrls: ['header-actions-button.component.scss'],
})
export class HeaderActionsButtonComponent implements OnChanges {

    @Input() actions: HeaderAction[] = [];

    @Input() layout: 'row' | 'column' = 'row';

    public completeActions: HeaderAction[] = [];
    constructor(
        private router: Router,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.actions) {
            this.completeActions = this.actions.map((action) => ({
                ...action,
                isLink: action.route && (action.route.startsWith('https://') || action.route.startsWith('http://')),
            }));
        }
    }

    public getTooltip(action: HeaderAction): string {
        return action.loading ? 'Chargement en cours' : action.tooltip;
    }

    public click(action: HeaderAction) {
        if (action.click) {
            action.click();
        }
        if (action.route) {
            return this.router.navigate([action.route]);
        }
    }

}
